import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

type RequireModuleProps = {
  moduleKey: string
  fallbackTo?: string
  children: React.ReactNode
}

export function RequireModule({ moduleKey, fallbackTo = '/app/consumptions', children }: RequireModuleProps) {
  const location = useLocation()
  const user = useAuthStore((s) => s.user)

  if (!user) {
    return <Navigate to="/login" replace />
  }

  const enabled = user.modules?.includes(moduleKey) ?? false
  if (!enabled) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`${fallbackTo}?next=${next}`} replace />
  }

  return <>{children}</>
}
